/* eslint-disable*/
import React from 'react'
import { WithRouter } from '@/components/WithRouter'

// import dd from 'dingtalk-jsapi'
import AppHeader from '@/components/AppHeader'
import ClientMaternitySider from '@/components/ClientMaternitySider'
import ClientOutletGuard from '@/components/ClientOutletGuard'
import { getClientSiderGroupKey } from '@/components/AppHeader/menus'

class ClientPage extends React.Component {
  // React V18 弃用componentWillMount生命周期
  // async UNSAFE_componentWillMount
  // async componentDidMount (){
  //   try {
  //     const { location: { origin } } = window
  //     const { browserType } = this.props
  //     if (browserType.environment === 'dingtalk') {
  //       dd.biz.util.openLink({
  //         url: origin,//要打开链接的地址
  //         onSuccess: (result) => {
  //           console.log('onSuccess', result)
  //         },
  //         onFail: (err) => {
  //           console.log('onFail', err)
  //         }
  //       })
  //     }
  //   } catch (err) {
  //   }
  // }
  render () {
    const { location } = this.props
    const isWorldHud = (location?.pathname || '').includes('/worldCommandCenter')
    const isSurveillance = (location?.pathname || '').includes('/surveillance')
    const isVisualScreen = (location?.pathname || '').includes('/visualScreen')
    const hideAppHeader =
      isVisualScreen || (location?.pathname || '').includes('/order/dispatchNewOrdersMobile')
    const siderGroupKey = getClientSiderGroupKey(location?.pathname || '')
    const showSider = !!siderGroupKey
    const pageBody = showSider ? (
      <div className="client-app__body">
        <ClientMaternitySider groupKey={siderGroupKey} collapsible={isSurveillance} />
        <div className="client-app__main">
          <ClientOutletGuard />
        </div>
      </div>
    ) : (
      <ClientOutletGuard />
    )
    return (
      <div
        className={`client-app${isWorldHud ? ' client-app--world-hud' : ''}${
          isSurveillance ? ' client-app--surveillance' : ''
        }${isVisualScreen ? ' client-app--visual-screen' : ''}${
          hideAppHeader ? ' client-app--no-header' : ''
        }${showSider ? ' client-app--with-sider' : ''}`}
      >
        {!hideAppHeader && (
          <AppHeader>
            {/* { defaultPath } */}
          </AppHeader>
        )}
        {pageBody}
      </div>
    )
  }
}

export default WithRouter(ClientPage)
